import { render } from "./ClientDocumentosEmitidos.vue?vue&type=template&id=4f2b4a26&scoped=true"
import script from "./ClientDocumentosEmitidos.vue?vue&type=script&lang=js"
export * from "./ClientDocumentosEmitidos.vue?vue&type=script&lang=js"

import "./ClientDocumentosEmitidos.vue?vue&type=style&index=0&id=4f2b4a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2b4a26"]])

export default __exports__